export enum WebsitePostType {
    BLOG = 0,
    GUIDE = 1,
}
